// extracted by mini-css-extract-plugin
export default {"bg_no_data":"NoData_bg_no_data__f-dtk","no_data_text":"NoData_no_data_text__BsrAr"};